import React from 'react';

import DSPDropdown from 'components/data-containers/PositionsTable/TableControls/DSPDropdown';
import DSPToggle from 'components/data-containers/PositionsTable/TableControls/DSPToggle';
import ChartsTabsHeader from '../shared/ChartsTabsHeader';

import { ChartTypes } from 'types/shared';
import { IToggleOption } from 'components/data-containers/PositionsTable/TableControls/DSPToggle';

import { DSPWrap, TabsWrapper } from '../styles';

interface ITabsProps {
  isLargeScreen: boolean;
  chartPage: ChartTypes;
  title: string;
  isLoadingCustomers: boolean;
  selectedCustomer: IToggleOption | null;
  uniqueCustomers: IToggleOption[];
  setSelectedCustomer: (customer: IToggleOption) => void;
  variation: string;
}

const Tabs: React.FC<ITabsProps> = (props) => {
  const {
    isLargeScreen,
    chartPage,
    title,
    uniqueCustomers,
    selectedCustomer,
    variation,
    setSelectedCustomer,
    isLoadingCustomers,
  } = props;
  return (
    <TabsWrapper>
      <ChartsTabsHeader
        isLargeScreen={isLargeScreen}
        chartPage={chartPage}
        title={title}
      />

      {!isLoadingCustomers && selectedCustomer && (
        <DSPWrap isLargeScreen={isLargeScreen}>
          {isLargeScreen ? (
            <DSPToggle
              options={uniqueCustomers}
              selectedCustomer={selectedCustomer}
              setSelectedCustomer={setSelectedCustomer}
              variation={variation}
              isIconDisplayed={chartPage === 'dsp'}
            />
          ) : (
            <DSPDropdown
              options={uniqueCustomers}
              selectedCustomer={selectedCustomer}
              setSelectedCustomer={setSelectedCustomer}
              isIconDisplayed={chartPage === 'dsp'}
            />
          )}
        </DSPWrap>
      )}
    </TabsWrapper>
  );
};

export default Tabs;
